declare const course_datas: {
  [key: string]: { reference: string; label: string }[];
};
declare const valeur_prospect;
declare global {
interface Window {
    dataLayer: Record<string, any>[];
  }
}

window.dataLayer = window.dataLayer || [];

import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initContactForm(): void {
    document.querySelectorAll<HTMLFormElement>('.js-contact-form').forEach($container => {
        new ContactForm($container);
    });
}

class ContactForm {
  $el: HTMLElement;
  $formationsRepeater: HTMLElement | null;
  $formationsSelect: HTMLSelectElement | null;
  $formulaireWrapper: HTMLElement | null;
  $zipCodeField: HTMLInputElement | null;
  $cityField: HTMLSelectElement | null;
  course_datas_flat: Record<string, string> = {};

  constructor($el: HTMLElement) {
      this.$el = $el;
      this.$formulaireWrapper = $el.querySelector('.formulaire-wrapper');
      this.$formationsSelect = $el.querySelector('.js-formation-course-data');
      this.$formationsRepeater = $el.querySelector('.js-formation-repeater');
      this.$zipCodeField = $el.querySelector('input[name="zipcode"]');
      this.$cityField = $el.querySelector('input[name="city"]');
      this.init();
  }

  init(): void {
      // Le repeater des formations
      if (this.$formationsRepeater) {
          // Création du bouton "Ajouter"
          const addButton = document.createElement('button');
          addButton.textContent = this.$formationsRepeater?.dataset.btnAddFormationTitle || 'Ajouter';
          addButton.type = 'button';
          addButton.classList.add('btn-add-formation');

          this.$formationsRepeater.appendChild(addButton);

          // Flag pour savoir si le nom du champ d’origine a été modifié
          let nameChanged = false;

          addButton.addEventListener('click', () => {
              const firstRow = this.$formationsRepeater?.querySelector('.row');
              if (!firstRow) return;

              if (!nameChanged) {
                  firstRow.querySelectorAll('[name]').forEach((field) => {
                      const name = field.getAttribute('name');
                      if (name && !name.endsWith('[]')) {
                          field.setAttribute('name', `${name}[]`);
                      }
                      if (
                          field instanceof HTMLInputElement ||
                          field instanceof HTMLSelectElement ||
                          field instanceof HTMLTextAreaElement
                      ) {
                          field.required = true;
                      }
                  });
                  nameChanged = true;
              }

              // Cloner la ligne
              const newRow = firstRow.cloneNode(true) as HTMLElement;
              newRow.classList.add('duplicated');
              newRow.classList.remove('prefilled');

              const select = newRow.querySelector('select') as HTMLSelectElement;
              select.classList.remove('readonly');
              // Supprimer les inputs ajoutés dynamiquement si present
              newRow.querySelectorAll('input[type="text"], input[type="hidden"][name="formation-categorie[]"]').forEach(el => el.remove());
              
              // Réinitialiser les champs du clone
              newRow.querySelectorAll('input, textarea, select').forEach((el) => {
                  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement) {
                      el.value = '';
                      el.required = true;
                  }
              });

              // Supprimer les anciens boutons du clone
              newRow.querySelectorAll('button').forEach((btn) => btn.remove());

              // Modifier les noms des champs clonés pour avoir []
              newRow.querySelectorAll('[name]').forEach((field) => {
                  const name = field.getAttribute('name');
                  if (name && !name.endsWith('[]')) {
                      field.setAttribute('name', `${name}[]`);
                  }
              });

              // Ajouter le bouton Supprimer
              this.addDeleteButtonToRepeatedRow(newRow);

              // Insérer la ligne clonée avant le bouton Ajouter
              this.$formationsRepeater?.insertBefore(newRow, addButton);
          });
      }

      // Insérer les optgroup dans select formation
      if (this.$formationsSelect) {
          const firstOption = this.$formationsSelect.querySelector('option');
          
          this.$formationsSelect.options.length = 0;

          if (firstOption) {
              this.$formationsSelect.appendChild(firstOption);
          }

          // Remplit dynamiquement le select
          for (const group in course_datas) {
              if (Object.prototype.hasOwnProperty.call(course_datas, group)) {
                  const optgroup = document.createElement('optgroup');
                  optgroup.label = group;

                  course_datas[group].forEach(item => {
                      if (item.label) {
                          const option = document.createElement('option');
                          option.value = item.reference;
                          option.textContent = item.label;
                          optgroup.appendChild(option);
                          this.course_datas_flat[item.reference] = item.label;
                      }
                  });

                  this.$formationsSelect.appendChild(optgroup);
              }
          }
          // Réinjection différée de l'input display
          setTimeout(() => this.injectFormationDisplayInput(), 1000);
      }

      // Liaison entre le champ zipcode et city
      const cityField = this.$cityField;
      
      this.$zipCodeField?.addEventListener('blur', function (evt) {
          const ele = evt.target as HTMLInputElement;
          const value = ele.value;
          const formData = new URLSearchParams();
          formData.append('action', 'search_cp_multiples');
          formData.append('cp', value);
          const wrapperCityField = cityField?.closest('div.wrapper-field');
          wrapperCityField?.querySelector('select')?.remove();
          
          if (cityField) {
              cityField.hidden = false;
          }

          if (value) {
              postData(script_var.ajax_url, formData).then(response => {
                  if (response.success && response.data.length > 0 && cityField) {
                      const cityFieldSelect = document.createElement('select');
                      cityField.value = response.data[0].city;
                      cityField.hidden = true;

                      response.data.forEach(item => {
                          const option = document.createElement('option');
                          option.value = item.city;
                          option.textContent = item.city;
                          cityFieldSelect?.appendChild(option);
                      });
                      
                      wrapperCityField?.appendChild(cityFieldSelect);
                      cityFieldSelect.addEventListener('change', (evt) => {
                          const selectElement = evt.target as HTMLSelectElement;
                          const selectedValue = selectElement.value;
                          cityField.value = selectedValue;
                      });
                      
                  }
              });
          }
      });

      // Tracking
      ['wpcf7mailsent', 'wpcf7mailfailed'].forEach(evt => {
            const wpcf7Elm = this.$el.querySelector('.wpcf7');
            type WPCF7Input = { name: string; value: string };

            wpcf7Elm?.addEventListener(evt, (event: Event) => {
                const customEvent = event as CustomEvent;
                const inputs = customEvent.detail?.inputs as WPCF7Input[] || [];
                const formationName = inputs.find(input => input.name === 'formation-name')?.value || null;
                let statut = inputs.find(input => input.name === 'statut')?.value || null;
                const email = inputs.find(input => input.name === 'email')?.value || null;
                const phone = inputs.find(input => input.name === 'phone')?.value || null;
                
                // Si Quizz
                const score = inputs.find(input => input.name === 'score')?.value || null;
                let formationCategories: string[] = [];

                if (score === null) {
                    formationCategories = inputs
                        .filter(input => input.name === 'formation-categorie' || input.name === 'formation-categorie[]')
                        .map(input => input.value);
                } else {
                    const formationCategorie = inputs.find(input => input.name === 'categorie-formation')?.value || null;
                    
                    if (formationCategorie !== null) {
                        formationCategories = [formationCategorie];
                    }

                    statut = 'Particulier';
                }

                const valeurLead = this.getAverageLeadValue(formationCategories, valeur_prospect);
                
                const datas: Record<string, any> = {
                    'event': 'cf7submission',
                    'valeur_prospect': valeurLead,
                    'provenance': document.referrer,
                    'formation': formationName,
                    'email': email,
                    'phone_number': phone,
                }
                
                if (statut) {
                    datas.statut = statut;
                }

                window.dataLayer.push(datas);
            });
        });

      if (this.$el.classList.contains('js-has-calendly')) {
          // Calendly par défaut
          let tagCalendar = this.$el.querySelector<HTMLTemplateElement>('#tag-calendar');
          
          const tagCalendarBilan = this.$el.querySelector<HTMLTemplateElement>('#tag-calendar-bilan');
          const tagCalendarBilanPro = this.$el.querySelector<HTMLTemplateElement>('#tag-calendar-professionnel-bilan');
          const tagCalendarFormationPro = this.$el.querySelector<HTMLTemplateElement>('#tag-calendar-professionnel-formation');
          
          // Calendly
          const wpcf7Elm = this.$el.querySelector('.wpcf7');

          wpcf7Elm?.addEventListener('wpcf7mailsent', (event: Event) => {
              const customEvent = event as CustomEvent<{
                  inputs: { name: string; value: string }[];
                  formData: FormData;
              }>;

              const inputs = customEvent.detail?.inputs || [];
              const formData = customEvent.detail?.formData;
              const statutInput = inputs.find(
                  (input: { name: string; value: string }) => input.name === 'statut'
              );
              const formationInput = inputs.filter(
                  (input: { name: string; value: string }) =>
                      input.name === 'formation-categorie' || input.name === 'formation-categorie[]'
              );
              
              let formationValue = '';

              for (const input of formationInput) {
                  const value = input.value.trim();
                  if (value) {
                      formationValue = value;
                      break;
                  }
              }
              
              // SI pas de statut, c'est forcément un professionnel
              const statutValue = statutInput ?  statutInput.value : 'Professionnel';

              if (formationValue && statutValue) {
                  // Bilan de compétence
                  if (formationValue === 'dw') {
                      if ('Professionnel' === statutValue) {
                          tagCalendar = tagCalendarBilanPro;
                      } else {
                          tagCalendar = tagCalendarBilan;
                      }
                  } else {
                      if ('Professionnel' === statutValue) {
                          tagCalendar = tagCalendarFormationPro;
                      }
                  }
              }
              

              if (this.$formulaireWrapper && tagCalendar) {
                  this.$formulaireWrapper.innerHTML = '';
                  const clonedContent = tagCalendar.content?.cloneNode(true);
                  
                  this.$formulaireWrapper.appendChild(clonedContent);
                  const calendlyWidget = document.querySelector<HTMLElement>('.calendly-inline-widget');

                  if (calendlyWidget) {
                      this.calendlyInitInlineWidgetCall(calendlyWidget, this.$formulaireWrapper, formData);
                  }
              }

              window.addEventListener("message", (e: MessageEvent) => {
                  if (e.data.event === 'calendly.event_scheduled') {
                      const forms = Array.from(document.querySelectorAll<HTMLFormElement>('.stepper'));
                      
                      // Trouver le premier formulaire visible
                      const formVisible = forms.find(form => {
                          return window.getComputedStyle(form).display !== 'none';
                      });

                      if (formVisible) {
                          const formContainer = formVisible;
                          const stepsElement = formContainer.querySelector('.steps') as HTMLElement;

                          // Récupérer le nombre total d'étapes
                          const totalSteps = parseInt(stepsElement.dataset.nbSteps || '0', 10);
                          formContainer.dataset.currentStep = totalSteps.toString();

                          const modal = document.querySelector('dialog.single-formation-modal-contact') as HTMLDialogElement;
                          const formBlock = document.querySelector('.stepper') as HTMLElement;
                          const mainHeaderNav = document.querySelector('.main-header--sticky') as HTMLElement;
                        
                          if (modal && modal.open) {
                              modal.scrollTo({
                                  top: modal.scrollTop + (formBlock.offsetTop - stepsElement.offsetHeight),
                                  behavior: 'smooth'
                              });
                          } else {
                              window.scrollTo({
                                  top: formContainer.getBoundingClientRect().top - mainHeaderNav.offsetHeight + window.scrollY - 10,
                                  behavior: 'smooth'
                              });
                          }
                      }
                  }
              });
          });
      }
  }
  
  injectFormationDisplayInput(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const categorieFormation = urlParams.get('categorie-formation');
    
    if (!categorieFormation || !this.course_datas_flat[categorieFormation]) return;

    const labelToDisplay = this.course_datas_flat[categorieFormation] || categorieFormation;

    const inputDisplay = document.createElement('input');
    inputDisplay.type = 'text';
    inputDisplay.value = labelToDisplay;
    inputDisplay.readOnly = true;
    inputDisplay.classList.add('readonly');
    

    if (this.$formationsSelect?.parentElement) {
      this.$formationsSelect.parentElement.insertBefore(inputDisplay, this.$formationsSelect);
      //this.$formationsSelect.parentElement.insertBefore(inputHidden, this.$formationsSelect);
      // Sélectionner la première option du groupe correspondant
      const allOptions = Array.from(this.$formationsSelect.querySelectorAll('option'));
      const matchingOption = allOptions.find(option => option.value === categorieFormation);

      if (matchingOption) {
        this.$formationsSelect.value = matchingOption.value;
      }
       this.$formationsSelect.closest('.row')?.classList.add('prefilled');
    }
  }

  addDeleteButtonToRepeatedRow(row: HTMLElement) : void {
      const deleteButton = document.createElement('button');
      deleteButton.type = 'button';
      deleteButton.classList.add('btn-delete-formation');
      deleteButton.setAttribute('aria-label', 'Supprimer');

      deleteButton.addEventListener('click', () => {
          row.remove();
      });

      row.appendChild(deleteButton);
  }

  calendlyInitInlineWidgetCall(
      calendlyWidget: HTMLElement,
      form: HTMLElement,
      formData: FormData
  ): void {
      const formDataEntries = Object.fromEntries(formData.entries());
      
      const calendlyWidgetPrefill = {
          name: `${formDataEntries['firstname']} ${formDataEntries['lastname']}`,
          email: formDataEntries['email'] as string,
          customAnswers: {
              a1: this.formatPhoneToInternationalFR(formDataEntries['phone'] as string),
              a2: formDataEntries['zipcode'] as string,
          }
      };
      
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.onload = () => {
          const url = new URL(calendlyWidget.dataset.url || '');
          if (!url.searchParams.has('hide_gdpr_banner')) {
              url.searchParams.set('hide_gdpr_banner', '1');
          }

          Calendly.initInlineWidget({
              url: url.toString(),
              parentElement: calendlyWidget,
              prefill: calendlyWidgetPrefill
          });

          // Mise à jour de l'étape (data-current-step)
          const formContainer = form.closest('.stepper') as HTMLElement;
          const currentStep = parseInt(formContainer.dataset.currentStep || '0', 10);
          formContainer.dataset.currentStep = (currentStep + 1).toString();
          const mainHeaderNav = document.querySelector('.main-header') as HTMLElement;
          const top = formContainer.getBoundingClientRect().top - mainHeaderNav.offsetHeight + window.scrollY - 10;
          
          window.scrollTo({
              top:  top,
              behavior: 'smooth'
          });
      };
      document.body.appendChild(script);
  }

  getAverageLeadValue(
    categories: string[],
    valeurs: Record<string, string>
  ): number {
  const fallback = parseFloat(valeurs["global"] || "0");

  const total = categories.reduce((sum, cat) => {
    const val = cat in valeurs ? parseFloat(valeurs[cat]) : fallback;
    return sum + val;
  }, 0);

    return categories.length ? Math.round(total / categories.length) : 0;
    }

    formatPhoneToInternationalFR(phone: string): string {
        let cleaned = phone.replace(/\D/g, ''); // Supprime tout sauf les chiffres

        // Si le numéro commence par 0 et a 10 chiffres
        if (cleaned.length === 10 && cleaned.startsWith('0')) {
            cleaned = '+33' + cleaned.slice(1);
        } else if (cleaned.startsWith('33')) {
            cleaned = '+' + cleaned;
        } else if (!cleaned.startsWith('+')) {
            // Fallback générique si l'utilisateur oublie le +
            cleaned = '+' + cleaned;
        }
            return cleaned;
    }
}
